import { render, staticRenderFns } from "./risk-level-loader.vue?vue&type=template&id=224abcaf"
import script from "./risk-level-loader.vue?vue&type=script&lang=js"
export * from "./risk-level-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports